import { render, staticRenderFns } from "./notification-banner.vue?vue&type=template&id=0d980889"
import script from "./notification-banner.vue?vue&type=script&lang=ts"
export * from "./notification-banner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports